require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-needs-to-happen-for-the-idb-to-prioritize-nat.json") })
        }
      }, "path---en-us-update-what-needs-to-happen-for-the-idb-to-prioritize-nat");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-needs-to-happen-for-the-idb-to-prioritize-nat!./.cache/json/en-us-update-what-needs-to-happen-for-the-idb-to-prioritize-nat.json
// module id = 848
// module chunks = 231608221292675